//BFS will not work on weighted graphs since the path with the 
//fewest edges may not be the shortest if the edges it contains are expensive. 

// const enqueue = (item) => this.push(item);
// const dequeue = () => this.shift();

export function bfs(graph) {
    const visitedNodesIdInOrder = [];
    let queue = [];
    const startNodeId = graph.startNode
    graph.list[startNodeId].isVisited = true
    queue.push(startNodeId); 
     while (queue.length > 0) {
         let visiting = queue.shift();
         visitedNodesIdInOrder.push(visiting);
         for (let p = graph.list[visiting].getHead(); p !== null; p = p.next) { 
            var w = p.id
            if (graph.list[w].isVisited === false) { 
                graph.list[w].isVisited = true; 
                graph.list[w].previousNodeId = visiting;
                queue.push(w);
           }
        }
      }
      return visitedNodesIdInOrder;
    }